import { CheckCircle2 } from "lucide-react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { usePageTitle } from "@/hooks/use-page-title";
import { Helmet } from "react-helmet-async";

export default function PaymentSuccessPage() {
  usePageTitle("Payment Confirmed");
  return (
    <>
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <div className="min-h-screen flex flex-col" style={{ background: "#f8fafc" }}>
      <nav
        style={{
          background: "#fff",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          position: "sticky",
          top: 0,
          zIndex: 50,
          padding: "0 24px",
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link href="/">
          <img src="/logo-new.png" alt="QuoTrak" style={{ height: "3rem", cursor: "pointer" }} />
        </Link>
      </nav>

      <main className="flex-1 flex flex-col items-center justify-center px-4 py-16 text-center">
        <div className="w-full max-w-md mx-auto space-y-6">
          <div className="flex justify-center">
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "#dcfce7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CheckCircle2 style={{ width: 40, height: 40, color: "#16a34a" }} />
            </div>
          </div>

          <div className="space-y-2">
            <h1 className="text-3xl font-bold">Payment successful!</h1>
            <p className="text-muted-foreground max-w-sm mx-auto">
              Thank you — your payment has been received and your invoice has been marked as paid.
            </p>
          </div>

          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <Link href="/">
              <Button variant="outline">Back to Home</Button>
            </Link>
          </div>
        </div>
      </main>

      <footer
        style={{
          textAlign: "center",
          padding: "24px",
          color: "#9ca3af",
          fontSize: 13,
          borderTop: "1px solid #f1f5f9",
        }}
      >
        © {new Date().getFullYear()} QuoTrak. All rights reserved.
      </footer>
    </div>
    </>
  );
}
